// extracted by mini-css-extract-plugin
export default {"sandbox_badge":"styles_sandbox_badge__qqnDP"};